/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import * as zod from 'zod';


/**
 * **Required Permission(s):** ORG_PAYOUT_LIST
 */
export const listPayablesQueryPageDefault = 1;export const listPayablesQueryPageSizeDefault = 25;export const listPayablesQuerySortDescendingDefault = true;export const listPayablesQueryOverdueDefault = false;

export const listPayablesQueryParams = zod.object({
  "page": zod.number().default(listPayablesQueryPageDefault),
  "pageSize": zod.number().default(listPayablesQueryPageSizeDefault),
  "statuses": zod.array(zod.enum(['Scheduled', 'Released', 'Processing', 'Paid', 'Failed', 'Voided'])).optional(),
  "sortBy": zod.string().optional(),
  "sortDescending": zod.boolean().default(listPayablesQuerySortDescendingDefault),
  "overdue": zod.boolean().optional()
})

export const listPayablesResponseItemsItemSourceSourcesItemAddressAddressLine1Max = 255;

export const listPayablesResponseItemsItemSourceSourcesItemAddressAddressLine2Max = 255;

export const listPayablesResponseItemsItemSourceSourcesItemAddressCityMax = 255;

export const listPayablesResponseItemsItemSourceSourcesItemAddressStateMax = 2;

export const listPayablesResponseItemsItemSourceSourcesItemAddressZipMax = 10;

export const listPayablesResponseItemsItemSourceSourcesItemAddressCountryMax = 100;



export const listPayablesResponse = zod.object({
  "items": zod.array(zod.object({
  "payout": zod.object({
  "id": zod.string().uuid(),
  "payee": zod.object({
  "type": zod.enum(['User', 'Organization']),
  "id": zod.string().uuid()
}),
  "amount": zod.number(),
  "amountOwed": zod.number(),
  "disbursementTiming": zod.enum(['Standard', 'Early']),
  "currency": zod.string(),
  "status": zod.string(),
  "releaseDate": zod.string().datetime({}).nullish(),
  "createdDate": zod.string().datetime({}),
  "payeeName": zod.string().nullish(),
  "internalMemo": zod.string().nullish(),
  "payeeMemo": zod.string().nullish(),
  "overdueSince": zod.string().datetime({}).nullish(),
  "payoutRequestCount": zod.number()
}),
  "source": zod.object({
  "sources": zod.array(zod.object({
  "workflow": zod.enum(['Opportunity', 'FsmGenerated', 'TalentMemberGenerated', 'StaffMemberGenerated']),
  "address": zod.object({
  "addressLine1": zod.string().max(listPayablesResponseItemsItemSourceSourcesItemAddressAddressLine1Max).nullish(),
  "addressLine2": zod.string().max(listPayablesResponseItemsItemSourceSourcesItemAddressAddressLine2Max).nullish(),
  "city": zod.string().max(listPayablesResponseItemsItemSourceSourcesItemAddressCityMax).nullish(),
  "state": zod.string().max(listPayablesResponseItemsItemSourceSourcesItemAddressStateMax).nullish(),
  "zip": zod.string().max(listPayablesResponseItemsItemSourceSourcesItemAddressZipMax).nullish(),
  "country": zod.string().max(listPayablesResponseItemsItemSourceSourcesItemAddressCountryMax).nullish(),
  "googlePlaceId": zod.string().nullish(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "geocodeFailed": zod.boolean().nullish()
}).optional(),
  "opportunityClaim": zod.object({
  "opportunityClaimId": zod.string().uuid(),
  "opportunityTitle": zod.string()
}).optional(),
  "fsmCompletedWork": zod.object({
  "fsmCompletedWorkId": zod.string().uuid(),
  "description": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "customerName": zod.string().nullish(),
  "sourceReference": zod.string().nullish(),
  "platform": zod.enum(['ColdStandard', 'HousecallPro', 'PoolBrain', 'ServiceTitan', 'Skimmer']),
  "referenceType": zod.enum(['Invoice', 'RouteStop', 'WorkOrder', 'Visit', 'Reimbursement'])
}).optional(),
  "reimbursement": zod.object({
  "description": zod.string().nullish()
}).optional()
}))
})
})),
  "totalCount": zod.number(),
  "page": zod.number(),
  "pageSize": zod.number(),
  "totalPages": zod.number(),
  "hasNextPage": zod.boolean(),
  "hasPreviousPage": zod.boolean()
})

/**
 * **Required Permission(s):** ORG_PAYOUT_LIST
 */
export const getPayableStatsResponse = zod.object({
  "all": zod.number(),
  "scheduled": zod.number(),
  "released": zod.number(),
  "processing": zod.number(),
  "paid": zod.number(),
  "failed": zod.number(),
  "overdue": zod.number(),
  "voided": zod.number()
})

/**
 * **Required Permission(s):** ORG_PAYOUT_GET
 */
export const getPayableByIdParams = zod.object({
  "id": zod.string().uuid()
})

export const getPayableByIdResponseSourceSourcesItemAddressAddressLine1Max = 255;

export const getPayableByIdResponseSourceSourcesItemAddressAddressLine2Max = 255;

export const getPayableByIdResponseSourceSourcesItemAddressCityMax = 255;

export const getPayableByIdResponseSourceSourcesItemAddressStateMax = 2;

export const getPayableByIdResponseSourceSourcesItemAddressZipMax = 10;

export const getPayableByIdResponseSourceSourcesItemAddressCountryMax = 100;

export const getPayableByIdResponsePayoutRequestsItemSourceAddressAddressLine1Max = 255;

export const getPayableByIdResponsePayoutRequestsItemSourceAddressAddressLine2Max = 255;

export const getPayableByIdResponsePayoutRequestsItemSourceAddressCityMax = 255;

export const getPayableByIdResponsePayoutRequestsItemSourceAddressStateMax = 2;

export const getPayableByIdResponsePayoutRequestsItemSourceAddressZipMax = 10;

export const getPayableByIdResponsePayoutRequestsItemSourceAddressCountryMax = 100;



export const getPayableByIdResponse = zod.object({
  "id": zod.string().uuid(),
  "organizationId": zod.string().uuid(),
  "payee": zod.object({
  "type": zod.enum(['User', 'Organization']),
  "id": zod.string().uuid()
}),
  "payeeName": zod.string().nullish(),
  "amount": zod.number(),
  "amountOwed": zod.number(),
  "disbursementTiming": zod.enum(['Standard', 'Early']),
  "currency": zod.string(),
  "status": zod.string(),
  "releaseDate": zod.string().datetime({}).nullish(),
  "earlyDisbursement": zod.object({
  "offer": zod.object({
  "releaseDate": zod.string().datetime({}),
  "feeRate": zod.number(),
  "feeAmount": zod.number()
}),
  "election": zod.object({
  "electedAt": zod.string().datetime({}),
  "electedByUserId": zod.string().uuid().nullish()
}).optional()
}).optional(),
  "skippedAt": zod.string().datetime({}).nullish(),
  "skipReason": zod.enum(['InsufficientFunds', 'PaymentUnconfirmed', 'CannotBePaid', 'AwaitingRetry']).optional(),
  "overdueSince": zod.string().datetime({}).nullish(),
  "canRetryManually": zod.boolean(),
  "voidReason": zod.string().nullish(),
  "voidedAt": zod.string().datetime({}).nullish(),
  "voidedByUserId": zod.string().uuid().nullish(),
  "paidNowAt": zod.string().datetime({}).nullish(),
  "paidNowByUserId": zod.string().uuid().nullish(),
  "paidNowByName": zod.string().nullish(),
  "paidNowReason": zod.string().nullish(),
  "paidNowFromReleaseDate": zod.string().datetime({}).nullish(),
  "internalMemo": zod.string().nullish(),
  "payeeMemo": zod.string().nullish(),
  "approvedDate": zod.string().datetime({}).nullish(),
  "approvedBy": zod.string().uuid().nullish(),
  "createdDate": zod.string().datetime({}),
  "modifiedDate": zod.string().datetime({}),
  "createdByUserId": zod.string().uuid().nullish(),
  "modifiedByUserId": zod.string().uuid().nullish(),
  "source": zod.object({
  "sources": zod.array(zod.object({
  "workflow": zod.enum(['Opportunity', 'FsmGenerated', 'TalentMemberGenerated', 'StaffMemberGenerated']),
  "address": zod.object({
  "addressLine1": zod.string().max(getPayableByIdResponseSourceSourcesItemAddressAddressLine1Max).nullish(),
  "addressLine2": zod.string().max(getPayableByIdResponseSourceSourcesItemAddressAddressLine2Max).nullish(),
  "city": zod.string().max(getPayableByIdResponseSourceSourcesItemAddressCityMax).nullish(),
  "state": zod.string().max(getPayableByIdResponseSourceSourcesItemAddressStateMax).nullish(),
  "zip": zod.string().max(getPayableByIdResponseSourceSourcesItemAddressZipMax).nullish(),
  "country": zod.string().max(getPayableByIdResponseSourceSourcesItemAddressCountryMax).nullish(),
  "googlePlaceId": zod.string().nullish(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "geocodeFailed": zod.boolean().nullish()
}).optional(),
  "opportunityClaim": zod.object({
  "opportunityClaimId": zod.string().uuid(),
  "opportunityTitle": zod.string()
}).optional(),
  "fsmCompletedWork": zod.object({
  "fsmCompletedWorkId": zod.string().uuid(),
  "description": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "customerName": zod.string().nullish(),
  "sourceReference": zod.string().nullish(),
  "platform": zod.enum(['ColdStandard', 'HousecallPro', 'PoolBrain', 'ServiceTitan', 'Skimmer']),
  "referenceType": zod.enum(['Invoice', 'RouteStop', 'WorkOrder', 'Visit', 'Reimbursement'])
}).optional(),
  "reimbursement": zod.object({
  "description": zod.string().nullish()
}).optional()
}))
}).optional(),
  "amountPaid": zod.number(),
  "amountSettled": zod.number(),
  "paidInFullDate": zod.string().datetime({}).nullish(),
  "payments": zod.array(zod.object({
  "status": zod.string(),
  "isFailed": zod.boolean(),
  "isReturned": zod.boolean(),
  "amount": zod.number(),
  "allocatedAmount": zod.number(),
  "payoutCount": zod.number(),
  "rail": zod.string(),
  "providerTransactionId": zod.string().nullish(),
  "reference": zod.string(),
  "attemptType": zod.string().nullish(),
  "retriedByUserId": zod.string().uuid().nullish(),
  "retriedByName": zod.string().nullish(),
  "createdDate": zod.string().datetime({}),
  "initiatedDate": zod.string().datetime({}).nullish(),
  "settledDate": zod.string().datetime({}).nullish(),
  "returnedDate": zod.string().datetime({}).nullish(),
  "returnCode": zod.string().nullish(),
  "failureCode": zod.enum(['PayeeIdentityVerificationMissing', 'PayeeIdentitySuspended', 'PayeeBankAccountMissing', 'PayeeBankAccountNotApproved', 'PayeeBankAccountUnderReview', 'PayeeBankAccountRejected', 'PayeeBankAccountUnlinked', 'PayeeBankAccountReturned', 'PayeeCardMissing', 'PayeeCardNotApproved', 'PayeeCardUnderReview', 'PayeeCardRejected', 'PayeeCardNotOctCapable', 'PayeeCardNotDebit', 'PushToCardNotEnabledForOrganization', 'PushToCardNotEnabledForTalentMember', 'PayeeNotTalentMember', 'PayeeTalentMembershipInactive', 'PayerCredentialMissing', 'InsufficientBalance', 'ProviderError', 'ProviderFailure']).optional(),
  "payeeSuspensionReason": zod.string().nullish(),
  "failureCorrelationId": zod.string().nullish()
})),
  "payoutRequests": zod.array(zod.object({
  "payoutRequest": zod.object({
  "id": zod.string().uuid(),
  "payeeName": zod.string(),
  "amount": zod.number().nullish(),
  "status": zod.enum(['Pending', 'Returned', 'Denied', 'Approved']),
  "createdDate": zod.string().datetime({}),
  "concurrencyToken": zod.string(),
  "payoutSetupStatus": zod.enum(['OrganizationRelationshipNeeded', 'NotStarted', 'IdentityVerificationPending', 'PayoutMethodNeeded', 'BankAccountAwaitingReview', 'BankAccountRejected', 'BankAccountUnlinked', 'BankAccountReturned', 'DebitCardNotPayoutEligible', 'DebitCardPayoutsUnavailable', 'Ready']),
  "isPaymentEligible": zod.boolean(),
  "hasApprovedNonPrimaryBankAccount": zod.boolean(),
  "invoice": zod.object({
  "id": zod.string().uuid(),
  "number": zod.number(),
  "status": zod.enum(['Draft', 'Finalized', 'Paid', 'Voided'])
}).optional()
}),
  "source": zod.object({
  "workflow": zod.enum(['Opportunity', 'FsmGenerated', 'TalentMemberGenerated', 'StaffMemberGenerated']),
  "address": zod.object({
  "addressLine1": zod.string().max(getPayableByIdResponsePayoutRequestsItemSourceAddressAddressLine1Max).nullish(),
  "addressLine2": zod.string().max(getPayableByIdResponsePayoutRequestsItemSourceAddressAddressLine2Max).nullish(),
  "city": zod.string().max(getPayableByIdResponsePayoutRequestsItemSourceAddressCityMax).nullish(),
  "state": zod.string().max(getPayableByIdResponsePayoutRequestsItemSourceAddressStateMax).nullish(),
  "zip": zod.string().max(getPayableByIdResponsePayoutRequestsItemSourceAddressZipMax).nullish(),
  "country": zod.string().max(getPayableByIdResponsePayoutRequestsItemSourceAddressCountryMax).nullish(),
  "googlePlaceId": zod.string().nullish(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "geocodeFailed": zod.boolean().nullish()
}).optional(),
  "opportunityClaim": zod.object({
  "opportunityClaimId": zod.string().uuid(),
  "opportunityTitle": zod.string()
}).optional(),
  "fsmCompletedWork": zod.object({
  "fsmCompletedWorkId": zod.string().uuid(),
  "description": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "customerName": zod.string().nullish(),
  "sourceReference": zod.string().nullish(),
  "platform": zod.enum(['ColdStandard', 'HousecallPro', 'PoolBrain', 'ServiceTitan', 'Skimmer']),
  "referenceType": zod.enum(['Invoice', 'RouteStop', 'WorkOrder', 'Visit', 'Reimbursement'])
}).optional(),
  "reimbursement": zod.object({
  "description": zod.string().nullish()
}).optional()
}),
  "fsmGrouping": zod.object({
  "fsmCompletedWorkId": zod.string().uuid(),
  "allocationConfirmed": zod.boolean()
}).optional(),
  "payout": zod.object({
  "id": zod.string().uuid(),
  "payee": zod.object({
  "type": zod.enum(['User', 'Organization']),
  "id": zod.string().uuid()
}),
  "amount": zod.number(),
  "amountOwed": zod.number(),
  "disbursementTiming": zod.enum(['Standard', 'Early']),
  "currency": zod.string(),
  "status": zod.string(),
  "releaseDate": zod.string().datetime({}).nullish(),
  "createdDate": zod.string().datetime({}),
  "payeeName": zod.string().nullish(),
  "internalMemo": zod.string().nullish(),
  "payeeMemo": zod.string().nullish(),
  "overdueSince": zod.string().datetime({}).nullish(),
  "payoutRequestCount": zod.number()
}).optional()
}))
})

/**
 * **Required Permission(s):** ORG_PAYOUT_GET
 */
export const getPayableByPayoutRequestIdParams = zod.object({
  "payoutRequestId": zod.string().uuid()
})

export const getPayableByPayoutRequestIdResponseSourceSourcesItemAddressAddressLine1Max = 255;

export const getPayableByPayoutRequestIdResponseSourceSourcesItemAddressAddressLine2Max = 255;

export const getPayableByPayoutRequestIdResponseSourceSourcesItemAddressCityMax = 255;

export const getPayableByPayoutRequestIdResponseSourceSourcesItemAddressStateMax = 2;

export const getPayableByPayoutRequestIdResponseSourceSourcesItemAddressZipMax = 10;

export const getPayableByPayoutRequestIdResponseSourceSourcesItemAddressCountryMax = 100;

export const getPayableByPayoutRequestIdResponsePayoutRequestsItemSourceAddressAddressLine1Max = 255;

export const getPayableByPayoutRequestIdResponsePayoutRequestsItemSourceAddressAddressLine2Max = 255;

export const getPayableByPayoutRequestIdResponsePayoutRequestsItemSourceAddressCityMax = 255;

export const getPayableByPayoutRequestIdResponsePayoutRequestsItemSourceAddressStateMax = 2;

export const getPayableByPayoutRequestIdResponsePayoutRequestsItemSourceAddressZipMax = 10;

export const getPayableByPayoutRequestIdResponsePayoutRequestsItemSourceAddressCountryMax = 100;



export const getPayableByPayoutRequestIdResponse = zod.object({
  "id": zod.string().uuid(),
  "organizationId": zod.string().uuid(),
  "payee": zod.object({
  "type": zod.enum(['User', 'Organization']),
  "id": zod.string().uuid()
}),
  "payeeName": zod.string().nullish(),
  "amount": zod.number(),
  "amountOwed": zod.number(),
  "disbursementTiming": zod.enum(['Standard', 'Early']),
  "currency": zod.string(),
  "status": zod.string(),
  "releaseDate": zod.string().datetime({}).nullish(),
  "earlyDisbursement": zod.object({
  "offer": zod.object({
  "releaseDate": zod.string().datetime({}),
  "feeRate": zod.number(),
  "feeAmount": zod.number()
}),
  "election": zod.object({
  "electedAt": zod.string().datetime({}),
  "electedByUserId": zod.string().uuid().nullish()
}).optional()
}).optional(),
  "skippedAt": zod.string().datetime({}).nullish(),
  "skipReason": zod.enum(['InsufficientFunds', 'PaymentUnconfirmed', 'CannotBePaid', 'AwaitingRetry']).optional(),
  "overdueSince": zod.string().datetime({}).nullish(),
  "canRetryManually": zod.boolean(),
  "voidReason": zod.string().nullish(),
  "voidedAt": zod.string().datetime({}).nullish(),
  "voidedByUserId": zod.string().uuid().nullish(),
  "paidNowAt": zod.string().datetime({}).nullish(),
  "paidNowByUserId": zod.string().uuid().nullish(),
  "paidNowByName": zod.string().nullish(),
  "paidNowReason": zod.string().nullish(),
  "paidNowFromReleaseDate": zod.string().datetime({}).nullish(),
  "internalMemo": zod.string().nullish(),
  "payeeMemo": zod.string().nullish(),
  "approvedDate": zod.string().datetime({}).nullish(),
  "approvedBy": zod.string().uuid().nullish(),
  "createdDate": zod.string().datetime({}),
  "modifiedDate": zod.string().datetime({}),
  "createdByUserId": zod.string().uuid().nullish(),
  "modifiedByUserId": zod.string().uuid().nullish(),
  "source": zod.object({
  "sources": zod.array(zod.object({
  "workflow": zod.enum(['Opportunity', 'FsmGenerated', 'TalentMemberGenerated', 'StaffMemberGenerated']),
  "address": zod.object({
  "addressLine1": zod.string().max(getPayableByPayoutRequestIdResponseSourceSourcesItemAddressAddressLine1Max).nullish(),
  "addressLine2": zod.string().max(getPayableByPayoutRequestIdResponseSourceSourcesItemAddressAddressLine2Max).nullish(),
  "city": zod.string().max(getPayableByPayoutRequestIdResponseSourceSourcesItemAddressCityMax).nullish(),
  "state": zod.string().max(getPayableByPayoutRequestIdResponseSourceSourcesItemAddressStateMax).nullish(),
  "zip": zod.string().max(getPayableByPayoutRequestIdResponseSourceSourcesItemAddressZipMax).nullish(),
  "country": zod.string().max(getPayableByPayoutRequestIdResponseSourceSourcesItemAddressCountryMax).nullish(),
  "googlePlaceId": zod.string().nullish(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "geocodeFailed": zod.boolean().nullish()
}).optional(),
  "opportunityClaim": zod.object({
  "opportunityClaimId": zod.string().uuid(),
  "opportunityTitle": zod.string()
}).optional(),
  "fsmCompletedWork": zod.object({
  "fsmCompletedWorkId": zod.string().uuid(),
  "description": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "customerName": zod.string().nullish(),
  "sourceReference": zod.string().nullish(),
  "platform": zod.enum(['ColdStandard', 'HousecallPro', 'PoolBrain', 'ServiceTitan', 'Skimmer']),
  "referenceType": zod.enum(['Invoice', 'RouteStop', 'WorkOrder', 'Visit', 'Reimbursement'])
}).optional(),
  "reimbursement": zod.object({
  "description": zod.string().nullish()
}).optional()
}))
}).optional(),
  "amountPaid": zod.number(),
  "amountSettled": zod.number(),
  "paidInFullDate": zod.string().datetime({}).nullish(),
  "payments": zod.array(zod.object({
  "status": zod.string(),
  "isFailed": zod.boolean(),
  "isReturned": zod.boolean(),
  "amount": zod.number(),
  "allocatedAmount": zod.number(),
  "payoutCount": zod.number(),
  "rail": zod.string(),
  "providerTransactionId": zod.string().nullish(),
  "reference": zod.string(),
  "attemptType": zod.string().nullish(),
  "retriedByUserId": zod.string().uuid().nullish(),
  "retriedByName": zod.string().nullish(),
  "createdDate": zod.string().datetime({}),
  "initiatedDate": zod.string().datetime({}).nullish(),
  "settledDate": zod.string().datetime({}).nullish(),
  "returnedDate": zod.string().datetime({}).nullish(),
  "returnCode": zod.string().nullish(),
  "failureCode": zod.enum(['PayeeIdentityVerificationMissing', 'PayeeIdentitySuspended', 'PayeeBankAccountMissing', 'PayeeBankAccountNotApproved', 'PayeeBankAccountUnderReview', 'PayeeBankAccountRejected', 'PayeeBankAccountUnlinked', 'PayeeBankAccountReturned', 'PayeeCardMissing', 'PayeeCardNotApproved', 'PayeeCardUnderReview', 'PayeeCardRejected', 'PayeeCardNotOctCapable', 'PayeeCardNotDebit', 'PushToCardNotEnabledForOrganization', 'PushToCardNotEnabledForTalentMember', 'PayeeNotTalentMember', 'PayeeTalentMembershipInactive', 'PayerCredentialMissing', 'InsufficientBalance', 'ProviderError', 'ProviderFailure']).optional(),
  "payeeSuspensionReason": zod.string().nullish(),
  "failureCorrelationId": zod.string().nullish()
})),
  "payoutRequests": zod.array(zod.object({
  "payoutRequest": zod.object({
  "id": zod.string().uuid(),
  "payeeName": zod.string(),
  "amount": zod.number().nullish(),
  "status": zod.enum(['Pending', 'Returned', 'Denied', 'Approved']),
  "createdDate": zod.string().datetime({}),
  "concurrencyToken": zod.string(),
  "payoutSetupStatus": zod.enum(['OrganizationRelationshipNeeded', 'NotStarted', 'IdentityVerificationPending', 'PayoutMethodNeeded', 'BankAccountAwaitingReview', 'BankAccountRejected', 'BankAccountUnlinked', 'BankAccountReturned', 'DebitCardNotPayoutEligible', 'DebitCardPayoutsUnavailable', 'Ready']),
  "isPaymentEligible": zod.boolean(),
  "hasApprovedNonPrimaryBankAccount": zod.boolean(),
  "invoice": zod.object({
  "id": zod.string().uuid(),
  "number": zod.number(),
  "status": zod.enum(['Draft', 'Finalized', 'Paid', 'Voided'])
}).optional()
}),
  "source": zod.object({
  "workflow": zod.enum(['Opportunity', 'FsmGenerated', 'TalentMemberGenerated', 'StaffMemberGenerated']),
  "address": zod.object({
  "addressLine1": zod.string().max(getPayableByPayoutRequestIdResponsePayoutRequestsItemSourceAddressAddressLine1Max).nullish(),
  "addressLine2": zod.string().max(getPayableByPayoutRequestIdResponsePayoutRequestsItemSourceAddressAddressLine2Max).nullish(),
  "city": zod.string().max(getPayableByPayoutRequestIdResponsePayoutRequestsItemSourceAddressCityMax).nullish(),
  "state": zod.string().max(getPayableByPayoutRequestIdResponsePayoutRequestsItemSourceAddressStateMax).nullish(),
  "zip": zod.string().max(getPayableByPayoutRequestIdResponsePayoutRequestsItemSourceAddressZipMax).nullish(),
  "country": zod.string().max(getPayableByPayoutRequestIdResponsePayoutRequestsItemSourceAddressCountryMax).nullish(),
  "googlePlaceId": zod.string().nullish(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "geocodeFailed": zod.boolean().nullish()
}).optional(),
  "opportunityClaim": zod.object({
  "opportunityClaimId": zod.string().uuid(),
  "opportunityTitle": zod.string()
}).optional(),
  "fsmCompletedWork": zod.object({
  "fsmCompletedWorkId": zod.string().uuid(),
  "description": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "customerName": zod.string().nullish(),
  "sourceReference": zod.string().nullish(),
  "platform": zod.enum(['ColdStandard', 'HousecallPro', 'PoolBrain', 'ServiceTitan', 'Skimmer']),
  "referenceType": zod.enum(['Invoice', 'RouteStop', 'WorkOrder', 'Visit', 'Reimbursement'])
}).optional(),
  "reimbursement": zod.object({
  "description": zod.string().nullish()
}).optional()
}),
  "fsmGrouping": zod.object({
  "fsmCompletedWorkId": zod.string().uuid(),
  "allocationConfirmed": zod.boolean()
}).optional(),
  "payout": zod.object({
  "id": zod.string().uuid(),
  "payee": zod.object({
  "type": zod.enum(['User', 'Organization']),
  "id": zod.string().uuid()
}),
  "amount": zod.number(),
  "amountOwed": zod.number(),
  "disbursementTiming": zod.enum(['Standard', 'Early']),
  "currency": zod.string(),
  "status": zod.string(),
  "releaseDate": zod.string().datetime({}).nullish(),
  "createdDate": zod.string().datetime({}),
  "payeeName": zod.string().nullish(),
  "internalMemo": zod.string().nullish(),
  "payeeMemo": zod.string().nullish(),
  "overdueSince": zod.string().datetime({}).nullish(),
  "payoutRequestCount": zod.number()
}).optional()
}))
})

/**
 * **Required Permission(s):** ORG_PAYOUT_PAY_NOW
 */
export const payPayoutNowParams = zod.object({
  "id": zod.string().uuid()
})

export const payPayoutNowBody = zod.object({
  "reason": zod.string()
})

export const payPayoutNowResponseSourceSourcesItemAddressAddressLine1Max = 255;

export const payPayoutNowResponseSourceSourcesItemAddressAddressLine2Max = 255;

export const payPayoutNowResponseSourceSourcesItemAddressCityMax = 255;

export const payPayoutNowResponseSourceSourcesItemAddressStateMax = 2;

export const payPayoutNowResponseSourceSourcesItemAddressZipMax = 10;

export const payPayoutNowResponseSourceSourcesItemAddressCountryMax = 100;

export const payPayoutNowResponsePayoutRequestsItemSourceAddressAddressLine1Max = 255;

export const payPayoutNowResponsePayoutRequestsItemSourceAddressAddressLine2Max = 255;

export const payPayoutNowResponsePayoutRequestsItemSourceAddressCityMax = 255;

export const payPayoutNowResponsePayoutRequestsItemSourceAddressStateMax = 2;

export const payPayoutNowResponsePayoutRequestsItemSourceAddressZipMax = 10;

export const payPayoutNowResponsePayoutRequestsItemSourceAddressCountryMax = 100;



export const payPayoutNowResponse = zod.object({
  "id": zod.string().uuid(),
  "organizationId": zod.string().uuid(),
  "payee": zod.object({
  "type": zod.enum(['User', 'Organization']),
  "id": zod.string().uuid()
}),
  "payeeName": zod.string().nullish(),
  "amount": zod.number(),
  "amountOwed": zod.number(),
  "disbursementTiming": zod.enum(['Standard', 'Early']),
  "currency": zod.string(),
  "status": zod.string(),
  "releaseDate": zod.string().datetime({}).nullish(),
  "earlyDisbursement": zod.object({
  "offer": zod.object({
  "releaseDate": zod.string().datetime({}),
  "feeRate": zod.number(),
  "feeAmount": zod.number()
}),
  "election": zod.object({
  "electedAt": zod.string().datetime({}),
  "electedByUserId": zod.string().uuid().nullish()
}).optional()
}).optional(),
  "skippedAt": zod.string().datetime({}).nullish(),
  "skipReason": zod.enum(['InsufficientFunds', 'PaymentUnconfirmed', 'CannotBePaid', 'AwaitingRetry']).optional(),
  "overdueSince": zod.string().datetime({}).nullish(),
  "canRetryManually": zod.boolean(),
  "voidReason": zod.string().nullish(),
  "voidedAt": zod.string().datetime({}).nullish(),
  "voidedByUserId": zod.string().uuid().nullish(),
  "paidNowAt": zod.string().datetime({}).nullish(),
  "paidNowByUserId": zod.string().uuid().nullish(),
  "paidNowByName": zod.string().nullish(),
  "paidNowReason": zod.string().nullish(),
  "paidNowFromReleaseDate": zod.string().datetime({}).nullish(),
  "internalMemo": zod.string().nullish(),
  "payeeMemo": zod.string().nullish(),
  "approvedDate": zod.string().datetime({}).nullish(),
  "approvedBy": zod.string().uuid().nullish(),
  "createdDate": zod.string().datetime({}),
  "modifiedDate": zod.string().datetime({}),
  "createdByUserId": zod.string().uuid().nullish(),
  "modifiedByUserId": zod.string().uuid().nullish(),
  "source": zod.object({
  "sources": zod.array(zod.object({
  "workflow": zod.enum(['Opportunity', 'FsmGenerated', 'TalentMemberGenerated', 'StaffMemberGenerated']),
  "address": zod.object({
  "addressLine1": zod.string().max(payPayoutNowResponseSourceSourcesItemAddressAddressLine1Max).nullish(),
  "addressLine2": zod.string().max(payPayoutNowResponseSourceSourcesItemAddressAddressLine2Max).nullish(),
  "city": zod.string().max(payPayoutNowResponseSourceSourcesItemAddressCityMax).nullish(),
  "state": zod.string().max(payPayoutNowResponseSourceSourcesItemAddressStateMax).nullish(),
  "zip": zod.string().max(payPayoutNowResponseSourceSourcesItemAddressZipMax).nullish(),
  "country": zod.string().max(payPayoutNowResponseSourceSourcesItemAddressCountryMax).nullish(),
  "googlePlaceId": zod.string().nullish(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "geocodeFailed": zod.boolean().nullish()
}).optional(),
  "opportunityClaim": zod.object({
  "opportunityClaimId": zod.string().uuid(),
  "opportunityTitle": zod.string()
}).optional(),
  "fsmCompletedWork": zod.object({
  "fsmCompletedWorkId": zod.string().uuid(),
  "description": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "customerName": zod.string().nullish(),
  "sourceReference": zod.string().nullish(),
  "platform": zod.enum(['ColdStandard', 'HousecallPro', 'PoolBrain', 'ServiceTitan', 'Skimmer']),
  "referenceType": zod.enum(['Invoice', 'RouteStop', 'WorkOrder', 'Visit', 'Reimbursement'])
}).optional(),
  "reimbursement": zod.object({
  "description": zod.string().nullish()
}).optional()
}))
}).optional(),
  "amountPaid": zod.number(),
  "amountSettled": zod.number(),
  "paidInFullDate": zod.string().datetime({}).nullish(),
  "payments": zod.array(zod.object({
  "status": zod.string(),
  "isFailed": zod.boolean(),
  "isReturned": zod.boolean(),
  "amount": zod.number(),
  "allocatedAmount": zod.number(),
  "payoutCount": zod.number(),
  "rail": zod.string(),
  "providerTransactionId": zod.string().nullish(),
  "reference": zod.string(),
  "attemptType": zod.string().nullish(),
  "retriedByUserId": zod.string().uuid().nullish(),
  "retriedByName": zod.string().nullish(),
  "createdDate": zod.string().datetime({}),
  "initiatedDate": zod.string().datetime({}).nullish(),
  "settledDate": zod.string().datetime({}).nullish(),
  "returnedDate": zod.string().datetime({}).nullish(),
  "returnCode": zod.string().nullish(),
  "failureCode": zod.enum(['PayeeIdentityVerificationMissing', 'PayeeIdentitySuspended', 'PayeeBankAccountMissing', 'PayeeBankAccountNotApproved', 'PayeeBankAccountUnderReview', 'PayeeBankAccountRejected', 'PayeeBankAccountUnlinked', 'PayeeBankAccountReturned', 'PayeeCardMissing', 'PayeeCardNotApproved', 'PayeeCardUnderReview', 'PayeeCardRejected', 'PayeeCardNotOctCapable', 'PayeeCardNotDebit', 'PushToCardNotEnabledForOrganization', 'PushToCardNotEnabledForTalentMember', 'PayeeNotTalentMember', 'PayeeTalentMembershipInactive', 'PayerCredentialMissing', 'InsufficientBalance', 'ProviderError', 'ProviderFailure']).optional(),
  "payeeSuspensionReason": zod.string().nullish(),
  "failureCorrelationId": zod.string().nullish()
})),
  "payoutRequests": zod.array(zod.object({
  "payoutRequest": zod.object({
  "id": zod.string().uuid(),
  "payeeName": zod.string(),
  "amount": zod.number().nullish(),
  "status": zod.enum(['Pending', 'Returned', 'Denied', 'Approved']),
  "createdDate": zod.string().datetime({}),
  "concurrencyToken": zod.string(),
  "payoutSetupStatus": zod.enum(['OrganizationRelationshipNeeded', 'NotStarted', 'IdentityVerificationPending', 'PayoutMethodNeeded', 'BankAccountAwaitingReview', 'BankAccountRejected', 'BankAccountUnlinked', 'BankAccountReturned', 'DebitCardNotPayoutEligible', 'DebitCardPayoutsUnavailable', 'Ready']),
  "isPaymentEligible": zod.boolean(),
  "hasApprovedNonPrimaryBankAccount": zod.boolean(),
  "invoice": zod.object({
  "id": zod.string().uuid(),
  "number": zod.number(),
  "status": zod.enum(['Draft', 'Finalized', 'Paid', 'Voided'])
}).optional()
}),
  "source": zod.object({
  "workflow": zod.enum(['Opportunity', 'FsmGenerated', 'TalentMemberGenerated', 'StaffMemberGenerated']),
  "address": zod.object({
  "addressLine1": zod.string().max(payPayoutNowResponsePayoutRequestsItemSourceAddressAddressLine1Max).nullish(),
  "addressLine2": zod.string().max(payPayoutNowResponsePayoutRequestsItemSourceAddressAddressLine2Max).nullish(),
  "city": zod.string().max(payPayoutNowResponsePayoutRequestsItemSourceAddressCityMax).nullish(),
  "state": zod.string().max(payPayoutNowResponsePayoutRequestsItemSourceAddressStateMax).nullish(),
  "zip": zod.string().max(payPayoutNowResponsePayoutRequestsItemSourceAddressZipMax).nullish(),
  "country": zod.string().max(payPayoutNowResponsePayoutRequestsItemSourceAddressCountryMax).nullish(),
  "googlePlaceId": zod.string().nullish(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "geocodeFailed": zod.boolean().nullish()
}).optional(),
  "opportunityClaim": zod.object({
  "opportunityClaimId": zod.string().uuid(),
  "opportunityTitle": zod.string()
}).optional(),
  "fsmCompletedWork": zod.object({
  "fsmCompletedWorkId": zod.string().uuid(),
  "description": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "customerName": zod.string().nullish(),
  "sourceReference": zod.string().nullish(),
  "platform": zod.enum(['ColdStandard', 'HousecallPro', 'PoolBrain', 'ServiceTitan', 'Skimmer']),
  "referenceType": zod.enum(['Invoice', 'RouteStop', 'WorkOrder', 'Visit', 'Reimbursement'])
}).optional(),
  "reimbursement": zod.object({
  "description": zod.string().nullish()
}).optional()
}),
  "fsmGrouping": zod.object({
  "fsmCompletedWorkId": zod.string().uuid(),
  "allocationConfirmed": zod.boolean()
}).optional(),
  "payout": zod.object({
  "id": zod.string().uuid(),
  "payee": zod.object({
  "type": zod.enum(['User', 'Organization']),
  "id": zod.string().uuid()
}),
  "amount": zod.number(),
  "amountOwed": zod.number(),
  "disbursementTiming": zod.enum(['Standard', 'Early']),
  "currency": zod.string(),
  "status": zod.string(),
  "releaseDate": zod.string().datetime({}).nullish(),
  "createdDate": zod.string().datetime({}),
  "payeeName": zod.string().nullish(),
  "internalMemo": zod.string().nullish(),
  "payeeMemo": zod.string().nullish(),
  "overdueSince": zod.string().datetime({}).nullish(),
  "payoutRequestCount": zod.number()
}).optional()
}))
})

/**
 * **Required Permission(s):** ORG_PAYOUT_PAY_NOW
 */
export const payPayoutsNowBody = zod.object({
  "payoutIds": zod.array(zod.string().uuid()),
  "reason": zod.string()
})

/**
 * **Required Permission(s):** ORG_PAYOUT_CREATE
 */
export const createPayoutBodyAmountMin = 0.01;
export const createPayoutBodyAmountMax = 10000;



export const createPayoutBody = zod.object({
  "payee": zod.object({
  "type": zod.enum(['User', 'Organization']),
  "id": zod.string().uuid()
}).optional(),
  "payeeId": zod.string().uuid().nullish(),
  "amount": zod.number().min(createPayoutBodyAmountMin).max(createPayoutBodyAmountMax),
  "internalMemo": zod.string(),
  "payeeMemo": zod.string()
})

/**
 * **Required Permission(s):** ORG_PAYOUT_UPDATE
 */
export const retryPayoutParams = zod.object({
  "id": zod.string().uuid()
})

export const retryPayoutResponseSourceSourcesItemAddressAddressLine1Max = 255;

export const retryPayoutResponseSourceSourcesItemAddressAddressLine2Max = 255;

export const retryPayoutResponseSourceSourcesItemAddressCityMax = 255;

export const retryPayoutResponseSourceSourcesItemAddressStateMax = 2;

export const retryPayoutResponseSourceSourcesItemAddressZipMax = 10;

export const retryPayoutResponseSourceSourcesItemAddressCountryMax = 100;

export const retryPayoutResponsePayoutRequestsItemSourceAddressAddressLine1Max = 255;

export const retryPayoutResponsePayoutRequestsItemSourceAddressAddressLine2Max = 255;

export const retryPayoutResponsePayoutRequestsItemSourceAddressCityMax = 255;

export const retryPayoutResponsePayoutRequestsItemSourceAddressStateMax = 2;

export const retryPayoutResponsePayoutRequestsItemSourceAddressZipMax = 10;

export const retryPayoutResponsePayoutRequestsItemSourceAddressCountryMax = 100;



export const retryPayoutResponse = zod.object({
  "id": zod.string().uuid(),
  "organizationId": zod.string().uuid(),
  "payee": zod.object({
  "type": zod.enum(['User', 'Organization']),
  "id": zod.string().uuid()
}),
  "payeeName": zod.string().nullish(),
  "amount": zod.number(),
  "amountOwed": zod.number(),
  "disbursementTiming": zod.enum(['Standard', 'Early']),
  "currency": zod.string(),
  "status": zod.string(),
  "releaseDate": zod.string().datetime({}).nullish(),
  "earlyDisbursement": zod.object({
  "offer": zod.object({
  "releaseDate": zod.string().datetime({}),
  "feeRate": zod.number(),
  "feeAmount": zod.number()
}),
  "election": zod.object({
  "electedAt": zod.string().datetime({}),
  "electedByUserId": zod.string().uuid().nullish()
}).optional()
}).optional(),
  "skippedAt": zod.string().datetime({}).nullish(),
  "skipReason": zod.enum(['InsufficientFunds', 'PaymentUnconfirmed', 'CannotBePaid', 'AwaitingRetry']).optional(),
  "overdueSince": zod.string().datetime({}).nullish(),
  "canRetryManually": zod.boolean(),
  "voidReason": zod.string().nullish(),
  "voidedAt": zod.string().datetime({}).nullish(),
  "voidedByUserId": zod.string().uuid().nullish(),
  "paidNowAt": zod.string().datetime({}).nullish(),
  "paidNowByUserId": zod.string().uuid().nullish(),
  "paidNowByName": zod.string().nullish(),
  "paidNowReason": zod.string().nullish(),
  "paidNowFromReleaseDate": zod.string().datetime({}).nullish(),
  "internalMemo": zod.string().nullish(),
  "payeeMemo": zod.string().nullish(),
  "approvedDate": zod.string().datetime({}).nullish(),
  "approvedBy": zod.string().uuid().nullish(),
  "createdDate": zod.string().datetime({}),
  "modifiedDate": zod.string().datetime({}),
  "createdByUserId": zod.string().uuid().nullish(),
  "modifiedByUserId": zod.string().uuid().nullish(),
  "source": zod.object({
  "sources": zod.array(zod.object({
  "workflow": zod.enum(['Opportunity', 'FsmGenerated', 'TalentMemberGenerated', 'StaffMemberGenerated']),
  "address": zod.object({
  "addressLine1": zod.string().max(retryPayoutResponseSourceSourcesItemAddressAddressLine1Max).nullish(),
  "addressLine2": zod.string().max(retryPayoutResponseSourceSourcesItemAddressAddressLine2Max).nullish(),
  "city": zod.string().max(retryPayoutResponseSourceSourcesItemAddressCityMax).nullish(),
  "state": zod.string().max(retryPayoutResponseSourceSourcesItemAddressStateMax).nullish(),
  "zip": zod.string().max(retryPayoutResponseSourceSourcesItemAddressZipMax).nullish(),
  "country": zod.string().max(retryPayoutResponseSourceSourcesItemAddressCountryMax).nullish(),
  "googlePlaceId": zod.string().nullish(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "geocodeFailed": zod.boolean().nullish()
}).optional(),
  "opportunityClaim": zod.object({
  "opportunityClaimId": zod.string().uuid(),
  "opportunityTitle": zod.string()
}).optional(),
  "fsmCompletedWork": zod.object({
  "fsmCompletedWorkId": zod.string().uuid(),
  "description": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "customerName": zod.string().nullish(),
  "sourceReference": zod.string().nullish(),
  "platform": zod.enum(['ColdStandard', 'HousecallPro', 'PoolBrain', 'ServiceTitan', 'Skimmer']),
  "referenceType": zod.enum(['Invoice', 'RouteStop', 'WorkOrder', 'Visit', 'Reimbursement'])
}).optional(),
  "reimbursement": zod.object({
  "description": zod.string().nullish()
}).optional()
}))
}).optional(),
  "amountPaid": zod.number(),
  "amountSettled": zod.number(),
  "paidInFullDate": zod.string().datetime({}).nullish(),
  "payments": zod.array(zod.object({
  "status": zod.string(),
  "isFailed": zod.boolean(),
  "isReturned": zod.boolean(),
  "amount": zod.number(),
  "allocatedAmount": zod.number(),
  "payoutCount": zod.number(),
  "rail": zod.string(),
  "providerTransactionId": zod.string().nullish(),
  "reference": zod.string(),
  "attemptType": zod.string().nullish(),
  "retriedByUserId": zod.string().uuid().nullish(),
  "retriedByName": zod.string().nullish(),
  "createdDate": zod.string().datetime({}),
  "initiatedDate": zod.string().datetime({}).nullish(),
  "settledDate": zod.string().datetime({}).nullish(),
  "returnedDate": zod.string().datetime({}).nullish(),
  "returnCode": zod.string().nullish(),
  "failureCode": zod.enum(['PayeeIdentityVerificationMissing', 'PayeeIdentitySuspended', 'PayeeBankAccountMissing', 'PayeeBankAccountNotApproved', 'PayeeBankAccountUnderReview', 'PayeeBankAccountRejected', 'PayeeBankAccountUnlinked', 'PayeeBankAccountReturned', 'PayeeCardMissing', 'PayeeCardNotApproved', 'PayeeCardUnderReview', 'PayeeCardRejected', 'PayeeCardNotOctCapable', 'PayeeCardNotDebit', 'PushToCardNotEnabledForOrganization', 'PushToCardNotEnabledForTalentMember', 'PayeeNotTalentMember', 'PayeeTalentMembershipInactive', 'PayerCredentialMissing', 'InsufficientBalance', 'ProviderError', 'ProviderFailure']).optional(),
  "payeeSuspensionReason": zod.string().nullish(),
  "failureCorrelationId": zod.string().nullish()
})),
  "payoutRequests": zod.array(zod.object({
  "payoutRequest": zod.object({
  "id": zod.string().uuid(),
  "payeeName": zod.string(),
  "amount": zod.number().nullish(),
  "status": zod.enum(['Pending', 'Returned', 'Denied', 'Approved']),
  "createdDate": zod.string().datetime({}),
  "concurrencyToken": zod.string(),
  "payoutSetupStatus": zod.enum(['OrganizationRelationshipNeeded', 'NotStarted', 'IdentityVerificationPending', 'PayoutMethodNeeded', 'BankAccountAwaitingReview', 'BankAccountRejected', 'BankAccountUnlinked', 'BankAccountReturned', 'DebitCardNotPayoutEligible', 'DebitCardPayoutsUnavailable', 'Ready']),
  "isPaymentEligible": zod.boolean(),
  "hasApprovedNonPrimaryBankAccount": zod.boolean(),
  "invoice": zod.object({
  "id": zod.string().uuid(),
  "number": zod.number(),
  "status": zod.enum(['Draft', 'Finalized', 'Paid', 'Voided'])
}).optional()
}),
  "source": zod.object({
  "workflow": zod.enum(['Opportunity', 'FsmGenerated', 'TalentMemberGenerated', 'StaffMemberGenerated']),
  "address": zod.object({
  "addressLine1": zod.string().max(retryPayoutResponsePayoutRequestsItemSourceAddressAddressLine1Max).nullish(),
  "addressLine2": zod.string().max(retryPayoutResponsePayoutRequestsItemSourceAddressAddressLine2Max).nullish(),
  "city": zod.string().max(retryPayoutResponsePayoutRequestsItemSourceAddressCityMax).nullish(),
  "state": zod.string().max(retryPayoutResponsePayoutRequestsItemSourceAddressStateMax).nullish(),
  "zip": zod.string().max(retryPayoutResponsePayoutRequestsItemSourceAddressZipMax).nullish(),
  "country": zod.string().max(retryPayoutResponsePayoutRequestsItemSourceAddressCountryMax).nullish(),
  "googlePlaceId": zod.string().nullish(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "geocodeFailed": zod.boolean().nullish()
}).optional(),
  "opportunityClaim": zod.object({
  "opportunityClaimId": zod.string().uuid(),
  "opportunityTitle": zod.string()
}).optional(),
  "fsmCompletedWork": zod.object({
  "fsmCompletedWorkId": zod.string().uuid(),
  "description": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "customerName": zod.string().nullish(),
  "sourceReference": zod.string().nullish(),
  "platform": zod.enum(['ColdStandard', 'HousecallPro', 'PoolBrain', 'ServiceTitan', 'Skimmer']),
  "referenceType": zod.enum(['Invoice', 'RouteStop', 'WorkOrder', 'Visit', 'Reimbursement'])
}).optional(),
  "reimbursement": zod.object({
  "description": zod.string().nullish()
}).optional()
}),
  "fsmGrouping": zod.object({
  "fsmCompletedWorkId": zod.string().uuid(),
  "allocationConfirmed": zod.boolean()
}).optional(),
  "payout": zod.object({
  "id": zod.string().uuid(),
  "payee": zod.object({
  "type": zod.enum(['User', 'Organization']),
  "id": zod.string().uuid()
}),
  "amount": zod.number(),
  "amountOwed": zod.number(),
  "disbursementTiming": zod.enum(['Standard', 'Early']),
  "currency": zod.string(),
  "status": zod.string(),
  "releaseDate": zod.string().datetime({}).nullish(),
  "createdDate": zod.string().datetime({}),
  "payeeName": zod.string().nullish(),
  "internalMemo": zod.string().nullish(),
  "payeeMemo": zod.string().nullish(),
  "overdueSince": zod.string().datetime({}).nullish(),
  "payoutRequestCount": zod.number()
}).optional()
}))
})

/**
 * **Required Permission(s):** ORG_PAYOUT_VOID
 */
export const voidPayoutParams = zod.object({
  "id": zod.string().uuid()
})

export const voidPayoutBody = zod.object({
  "reason": zod.string()
})

export const voidPayoutResponseSourceSourcesItemAddressAddressLine1Max = 255;

export const voidPayoutResponseSourceSourcesItemAddressAddressLine2Max = 255;

export const voidPayoutResponseSourceSourcesItemAddressCityMax = 255;

export const voidPayoutResponseSourceSourcesItemAddressStateMax = 2;

export const voidPayoutResponseSourceSourcesItemAddressZipMax = 10;

export const voidPayoutResponseSourceSourcesItemAddressCountryMax = 100;

export const voidPayoutResponsePayoutRequestsItemSourceAddressAddressLine1Max = 255;

export const voidPayoutResponsePayoutRequestsItemSourceAddressAddressLine2Max = 255;

export const voidPayoutResponsePayoutRequestsItemSourceAddressCityMax = 255;

export const voidPayoutResponsePayoutRequestsItemSourceAddressStateMax = 2;

export const voidPayoutResponsePayoutRequestsItemSourceAddressZipMax = 10;

export const voidPayoutResponsePayoutRequestsItemSourceAddressCountryMax = 100;



export const voidPayoutResponse = zod.object({
  "id": zod.string().uuid(),
  "organizationId": zod.string().uuid(),
  "payee": zod.object({
  "type": zod.enum(['User', 'Organization']),
  "id": zod.string().uuid()
}),
  "payeeName": zod.string().nullish(),
  "amount": zod.number(),
  "amountOwed": zod.number(),
  "disbursementTiming": zod.enum(['Standard', 'Early']),
  "currency": zod.string(),
  "status": zod.string(),
  "releaseDate": zod.string().datetime({}).nullish(),
  "earlyDisbursement": zod.object({
  "offer": zod.object({
  "releaseDate": zod.string().datetime({}),
  "feeRate": zod.number(),
  "feeAmount": zod.number()
}),
  "election": zod.object({
  "electedAt": zod.string().datetime({}),
  "electedByUserId": zod.string().uuid().nullish()
}).optional()
}).optional(),
  "skippedAt": zod.string().datetime({}).nullish(),
  "skipReason": zod.enum(['InsufficientFunds', 'PaymentUnconfirmed', 'CannotBePaid', 'AwaitingRetry']).optional(),
  "overdueSince": zod.string().datetime({}).nullish(),
  "canRetryManually": zod.boolean(),
  "voidReason": zod.string().nullish(),
  "voidedAt": zod.string().datetime({}).nullish(),
  "voidedByUserId": zod.string().uuid().nullish(),
  "paidNowAt": zod.string().datetime({}).nullish(),
  "paidNowByUserId": zod.string().uuid().nullish(),
  "paidNowByName": zod.string().nullish(),
  "paidNowReason": zod.string().nullish(),
  "paidNowFromReleaseDate": zod.string().datetime({}).nullish(),
  "internalMemo": zod.string().nullish(),
  "payeeMemo": zod.string().nullish(),
  "approvedDate": zod.string().datetime({}).nullish(),
  "approvedBy": zod.string().uuid().nullish(),
  "createdDate": zod.string().datetime({}),
  "modifiedDate": zod.string().datetime({}),
  "createdByUserId": zod.string().uuid().nullish(),
  "modifiedByUserId": zod.string().uuid().nullish(),
  "source": zod.object({
  "sources": zod.array(zod.object({
  "workflow": zod.enum(['Opportunity', 'FsmGenerated', 'TalentMemberGenerated', 'StaffMemberGenerated']),
  "address": zod.object({
  "addressLine1": zod.string().max(voidPayoutResponseSourceSourcesItemAddressAddressLine1Max).nullish(),
  "addressLine2": zod.string().max(voidPayoutResponseSourceSourcesItemAddressAddressLine2Max).nullish(),
  "city": zod.string().max(voidPayoutResponseSourceSourcesItemAddressCityMax).nullish(),
  "state": zod.string().max(voidPayoutResponseSourceSourcesItemAddressStateMax).nullish(),
  "zip": zod.string().max(voidPayoutResponseSourceSourcesItemAddressZipMax).nullish(),
  "country": zod.string().max(voidPayoutResponseSourceSourcesItemAddressCountryMax).nullish(),
  "googlePlaceId": zod.string().nullish(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "geocodeFailed": zod.boolean().nullish()
}).optional(),
  "opportunityClaim": zod.object({
  "opportunityClaimId": zod.string().uuid(),
  "opportunityTitle": zod.string()
}).optional(),
  "fsmCompletedWork": zod.object({
  "fsmCompletedWorkId": zod.string().uuid(),
  "description": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "customerName": zod.string().nullish(),
  "sourceReference": zod.string().nullish(),
  "platform": zod.enum(['ColdStandard', 'HousecallPro', 'PoolBrain', 'ServiceTitan', 'Skimmer']),
  "referenceType": zod.enum(['Invoice', 'RouteStop', 'WorkOrder', 'Visit', 'Reimbursement'])
}).optional(),
  "reimbursement": zod.object({
  "description": zod.string().nullish()
}).optional()
}))
}).optional(),
  "amountPaid": zod.number(),
  "amountSettled": zod.number(),
  "paidInFullDate": zod.string().datetime({}).nullish(),
  "payments": zod.array(zod.object({
  "status": zod.string(),
  "isFailed": zod.boolean(),
  "isReturned": zod.boolean(),
  "amount": zod.number(),
  "allocatedAmount": zod.number(),
  "payoutCount": zod.number(),
  "rail": zod.string(),
  "providerTransactionId": zod.string().nullish(),
  "reference": zod.string(),
  "attemptType": zod.string().nullish(),
  "retriedByUserId": zod.string().uuid().nullish(),
  "retriedByName": zod.string().nullish(),
  "createdDate": zod.string().datetime({}),
  "initiatedDate": zod.string().datetime({}).nullish(),
  "settledDate": zod.string().datetime({}).nullish(),
  "returnedDate": zod.string().datetime({}).nullish(),
  "returnCode": zod.string().nullish(),
  "failureCode": zod.enum(['PayeeIdentityVerificationMissing', 'PayeeIdentitySuspended', 'PayeeBankAccountMissing', 'PayeeBankAccountNotApproved', 'PayeeBankAccountUnderReview', 'PayeeBankAccountRejected', 'PayeeBankAccountUnlinked', 'PayeeBankAccountReturned', 'PayeeCardMissing', 'PayeeCardNotApproved', 'PayeeCardUnderReview', 'PayeeCardRejected', 'PayeeCardNotOctCapable', 'PayeeCardNotDebit', 'PushToCardNotEnabledForOrganization', 'PushToCardNotEnabledForTalentMember', 'PayeeNotTalentMember', 'PayeeTalentMembershipInactive', 'PayerCredentialMissing', 'InsufficientBalance', 'ProviderError', 'ProviderFailure']).optional(),
  "payeeSuspensionReason": zod.string().nullish(),
  "failureCorrelationId": zod.string().nullish()
})),
  "payoutRequests": zod.array(zod.object({
  "payoutRequest": zod.object({
  "id": zod.string().uuid(),
  "payeeName": zod.string(),
  "amount": zod.number().nullish(),
  "status": zod.enum(['Pending', 'Returned', 'Denied', 'Approved']),
  "createdDate": zod.string().datetime({}),
  "concurrencyToken": zod.string(),
  "payoutSetupStatus": zod.enum(['OrganizationRelationshipNeeded', 'NotStarted', 'IdentityVerificationPending', 'PayoutMethodNeeded', 'BankAccountAwaitingReview', 'BankAccountRejected', 'BankAccountUnlinked', 'BankAccountReturned', 'DebitCardNotPayoutEligible', 'DebitCardPayoutsUnavailable', 'Ready']),
  "isPaymentEligible": zod.boolean(),
  "hasApprovedNonPrimaryBankAccount": zod.boolean(),
  "invoice": zod.object({
  "id": zod.string().uuid(),
  "number": zod.number(),
  "status": zod.enum(['Draft', 'Finalized', 'Paid', 'Voided'])
}).optional()
}),
  "source": zod.object({
  "workflow": zod.enum(['Opportunity', 'FsmGenerated', 'TalentMemberGenerated', 'StaffMemberGenerated']),
  "address": zod.object({
  "addressLine1": zod.string().max(voidPayoutResponsePayoutRequestsItemSourceAddressAddressLine1Max).nullish(),
  "addressLine2": zod.string().max(voidPayoutResponsePayoutRequestsItemSourceAddressAddressLine2Max).nullish(),
  "city": zod.string().max(voidPayoutResponsePayoutRequestsItemSourceAddressCityMax).nullish(),
  "state": zod.string().max(voidPayoutResponsePayoutRequestsItemSourceAddressStateMax).nullish(),
  "zip": zod.string().max(voidPayoutResponsePayoutRequestsItemSourceAddressZipMax).nullish(),
  "country": zod.string().max(voidPayoutResponsePayoutRequestsItemSourceAddressCountryMax).nullish(),
  "googlePlaceId": zod.string().nullish(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "geocodeFailed": zod.boolean().nullish()
}).optional(),
  "opportunityClaim": zod.object({
  "opportunityClaimId": zod.string().uuid(),
  "opportunityTitle": zod.string()
}).optional(),
  "fsmCompletedWork": zod.object({
  "fsmCompletedWorkId": zod.string().uuid(),
  "description": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "customerName": zod.string().nullish(),
  "sourceReference": zod.string().nullish(),
  "platform": zod.enum(['ColdStandard', 'HousecallPro', 'PoolBrain', 'ServiceTitan', 'Skimmer']),
  "referenceType": zod.enum(['Invoice', 'RouteStop', 'WorkOrder', 'Visit', 'Reimbursement'])
}).optional(),
  "reimbursement": zod.object({
  "description": zod.string().nullish()
}).optional()
}),
  "fsmGrouping": zod.object({
  "fsmCompletedWorkId": zod.string().uuid(),
  "allocationConfirmed": zod.boolean()
}).optional(),
  "payout": zod.object({
  "id": zod.string().uuid(),
  "payee": zod.object({
  "type": zod.enum(['User', 'Organization']),
  "id": zod.string().uuid()
}),
  "amount": zod.number(),
  "amountOwed": zod.number(),
  "disbursementTiming": zod.enum(['Standard', 'Early']),
  "currency": zod.string(),
  "status": zod.string(),
  "releaseDate": zod.string().datetime({}).nullish(),
  "createdDate": zod.string().datetime({}),
  "payeeName": zod.string().nullish(),
  "internalMemo": zod.string().nullish(),
  "payeeMemo": zod.string().nullish(),
  "overdueSince": zod.string().datetime({}).nullish(),
  "payoutRequestCount": zod.number()
}).optional()
}))
})

